/**
 * DashboardShell — ported from oakallow-nextjs/app/dashboard/layout.tsx.
 * Replaces the Next.js layout.tsx wrapping pattern with a React Router
 * layout route that renders <Outlet/> in place of `children`.
 *
 * Sidebar collapse state is persisted to localStorage under the same key
 * ("sidebar-collapsed") source used, so a user who collapsed the sidebar in
 * the old app keeps it collapsed after the cutover.
 */

import { useState, useEffect } from 'react';
import { Outlet } from 'react-router';
import Sidebar from './Sidebar';
import Header from './Header';
import OrgAlertBanner from './OrgAlertBanner';
import LockdownBanner from './LockdownBanner';

export default function DashboardShell() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('sidebar-collapsed');
    if (saved === 'true') setCollapsed(true);
  }, []);

  useEffect(() => {
    localStorage.setItem('sidebar-collapsed', String(collapsed));
  }, [collapsed]);

  return (
    <div className="dashboard-layout">
      <div
        className={`dashboard-sidebar ${sidebarOpen ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}
      >
        <Sidebar collapsed={collapsed} onToggleCollapse={() => setCollapsed(!collapsed)} />
      </div>
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
      )}
      <div className={`dashboard-main ${collapsed ? 'sidebar-collapsed' : ''}`}>
        <Header onToggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
        {/* Sits between the dashboard header and page content so it's
            visible on every route (Overview, Orgs, Billing, etc.).
            Owner+admin only — members get an empty list from
            /api/billing/alerts and the banner renders nothing. */}
        <OrgAlertBanner />
        {/* OakGuard lockdown: every team member, every page (except the
            oakGuard page, which has the full controls). */}
        <LockdownBanner />
        <div className="dashboard-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
